import { ReactElement } from "react";
import { SystemIcon } from "@justworkshr/milo-icons";
import styles from "./field-validation-indicator.module.css";
import { ValidationCriterion } from "../../types/validationCriterion";

const FieldValidationIndicator = ({
  validationCriteria,
}: {
  validationCriteria: Array<ValidationCriterion>;
}): ReactElement => {
  return (
    <div className={styles.container}>
      {validationCriteria.map((criterion, index) => (
        <div
          key={index}
          className={`${styles.indicator} ${
            criterion.isValid ? styles.valid : ""
          }`}
        >
          <SystemIcon
            size="small"
            iconName={criterion.isValid ? "check" : "arrow-right"}
            color={criterion.isValid ? "success" : "inverse-subtle"}
          />
          <div>{criterion.detail}</div>
        </div>
      ))}
    </div>
  );
};

export default FieldValidationIndicator;
